import React, { useState } from 'react';
import styled from 'styled-components'
import { useField } from 'react-final-form'
import { RadioButton, Divider } from 'vqp-common';

import { Button, CheckboxGroup, Checkbox, Collapse } from '../../common'
import { TimeInputGroup } from './'
import { RestrictionList } from './RestrictionsList';
import { useFieldArray } from 'react-final-form-arrays';
import { WEEKDAYS } from '../../../constants/time';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 20px;
`

const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
`

const Label = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: ${props => props.theme.colors.textBold};
`

const RadioGroup = styled.div`
    display: flex;
    flex-direction: row;
    font-size: 11px !important;
    color: ${props => props.theme.colors.textBold};
    margin-left: 10px;

    ${RadioButton} {
        & label {
            margin-bottom: 0;
        }
        & span {
            top: initial;
        }
    }
`

const Subtitle = styled.div`
    font-size: 12px;
    font-style: italic;
    margin-top: 20px;
`

const Weekdays = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 17px 0;
`

const CheckboxWrapper = styled.div`
    position: relative;
    font-size: 11px !important;
    color: ${props => props.theme.colors.textBold};
    margin-right: 10px;
`

const AddButton = styled(Button)`
    margin-left: 40px;
    width: 100px !important;
`

const ErrorBox = styled.div`
    height: 20px;
    align-self: flex-end;
    font-size: 11px;
    color: ${props => props.theme.colors.error};
`


export const ProductTimeRestrictions = ({ defaultHasRestrictions, defaultRestrictions }) => {

    const [checkedWeekdays, setCheckedWeekdays] = useState([])
    const [fromTime, setFromTime] = useState('')
    const [toTime, setToTime] = useState('')
    const [allChecked, setAllChecked] = useState(false)
    const [restrictions, setRestrictions] = useState(defaultRestrictions || [])
    const [error, setError] = useState('')

    const hasRestrictionsField = useField('hasRestrictions', { initialValue: defaultHasRestrictions || false })
    const restrictionsField = useFieldArray('restrictions', { initialValue: defaultRestrictions })

    const resetForm = () => {
        setAllChecked(false)
        setCheckedWeekdays([])
        setFromTime('')
        setToTime('')
        setError('')
    }

    const handleRestrictionCheck = (value) => {
        if (value === "true" && hasRestrictionsField.input.value !== true) {
            hasRestrictionsField.input.onChange(true)
        } else if (value === "false" && hasRestrictionsField.input.value !== false) {
            resetForm()
            hasRestrictionsField.input.onChange(false)
            setRestrictions([])
            for (let i = 0; i < restrictionsField.fields.length; i++) {
                restrictionsField.fields.pop()
            }
        }
    }

    const handleAllChecked = (checked) => {
        setAllChecked(checked)
        if (checked) {
            setCheckedWeekdays(WEEKDAYS.map(day => day.value))
        } else {
            setCheckedWeekdays([])
        }
    }

    const handleAddRestriction = () => {
        const formattedFromTime = `${fromTime}:00`
        const formattedToTime = `${toTime}:00`
        if (!checkedWeekdays || checkedWeekdays.length === 0) {
            setError('Selecione pelo menos um dia da semana')
            return false;
        }
        if (fromTime === '' || toTime === '') {
            setError('Digite um intervalo de tempo')
            return false;
        }
        const newRestrictions = restrictions ? [...restrictions] : []
        checkedWeekdays.forEach(day => {
            const index = newRestrictions.findIndex(r => r.day === day)
            if (index > -1) {
                newRestrictions[index].fromTime = formattedFromTime
                newRestrictions[index].toTime = formattedToTime
                restrictionsField.fields.update(index, newRestrictions[index])
            } else {
                const field = {
                    day,
                    fromTime: formattedFromTime,
                    toTime: formattedToTime
                }
                newRestrictions.push(field)
                restrictionsField.fields.push(field)
            }
        })
        setRestrictions(newRestrictions)
        resetForm()
    }

    return (
        <Wrapper>
            <Row>
                <Label>Há restrição de dias e horários?</Label>
                <RadioGroup>
                    <RadioButton value={"true"} name="timeRestriction" defaultChecked={hasRestrictionsField.input.value} onChange={handleRestrictionCheck}>
                        Sim
                    </RadioButton>
                    <RadioButton value={"false"} name="timeRestriction" defaultChecked={!hasRestrictionsField.input.value} onChange={handleRestrictionCheck}>
                        Não
                    </RadioButton>
                </RadioGroup>
            </Row>
            <Collapse isOpen={hasRestrictionsField.input.value}>
                <Subtitle>
                    Preencha os dias e horários na qual o produto deve estar disponível.
                </Subtitle>
                <Weekdays>
                    <CheckboxWrapper>
                        <Checkbox
                            checked={allChecked}
                            onCheck={handleAllChecked}
                        >TODOS</Checkbox>
                    </CheckboxWrapper>
                    <CheckboxGroup
                        key={Math.random()}
                        direction={"row"}
                        options={WEEKDAYS}
                        checkeds={checkedWeekdays}
                        onCheck={setCheckedWeekdays}
                        onChange={() => setAllChecked(false)}
                    />
                </Weekdays>
                <Row>
                    <TimeInputGroup fromTime={fromTime} toTime={toTime} onChangeFromTime={setFromTime} onChangeToTime={setToTime} />
                    <AddButton type="button" className="primary" onClick={handleAddRestriction}>Adicionar</AddButton>
                </Row>
                <Row>
                    <ErrorBox>{error}</ErrorBox>
                </Row>
                <Divider marginV={"10px"} />
                <RestrictionList field={restrictionsField.fields.name} restrictions={restrictions} />
            </Collapse>
        </Wrapper>
    )
}